import * as React from "react";
import { forwardRef } from "react";
const SvgSuccessIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ React.createElement("svg", {
	width: 148,
	height: 148,
	viewBox: "0 0 148 148",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props
}, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", {
	d: "M42.6899 56.2287L62.2842 83.6496C63.9189 85.9375 66.522 87.3387 69.3325 87.4434C72.1429 87.5482 74.8432 86.3447 76.6438 84.1848L140.84 7.16138",
	stroke: "#6BCE62",
	strokeWidth: 6,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M102.37 25.4402C76.0719 9.1698 41.8193 14.6189 21.8716 38.2465C1.92392 61.8741 2.30407 96.546 22.765 119.731C43.226 142.916 77.5898 147.613 103.525 130.77C129.461 113.927 139.137 80.6298 126.265 52.5162",
	stroke: "#6BCE62",
	strokeWidth: 6,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}));
const ForwardRef = forwardRef(SvgSuccessIcon);
export default ForwardRef;
